// @ts-nocheck
export const selectCompanies = state => state.company.companies;
export const selectCompanyDetails = state => state.company.companyDetails;
export const selectContractDetails = state => state.company.contractDetails;
export const selectCompanyProducts = state => state.company.companyProducts;
